<template>

  <vs-table
      ref="table"
      v-model="selected"
      search
      multiple
      :sst="true"
      :data="documents"
      @sort="handleSort"
      @search="search"
  >
    <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-end"
    >

      <p
          v-show="searchQuery"
          class="mr-4 mb-4"
      >Search results for '{{ searchQuery }}'</p>
      <!-- ACTIONS -->
      <vs-dropdown
          vs-trigger-click
          class="cursor-pointer mb-4 mr-4 items-per-page-handler"
      >
        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
          <span class="mr-2"> Actions </span>
          <feather-icon
              icon="ChevronDownIcon"
              svgClasses="h-4 w-4"
          />
        </div>
        <vs-dropdown-menu>
          <vs-dropdown-item @click="markCancelRetrievalFromStorage" :disabled="!selected.length">
            <span>Cancel Retrieval Request </span>
          </vs-dropdown-item>

        </vs-dropdown-menu>
      </vs-dropdown>

    </div>
    <template slot="thead">
      <vs-th sort-key="storage_id">Storage ID</vs-th>
      <vs-th sort-key="reference_number">Reference Number</vs-th>
      <vs-th sort-key="business">Owner</vs-th>
      <vs-th>Type</vs-th>
      <vs-th>Signed Date</vs-th>
      <vs-th sort-key="requested_from_storage_date__date">Date Requested From Storage</vs-th>
    </template>
    <template slot-scope="{data}">
      <tbody>
      <vs-tr
          :data="doc"
          :key="index"
          v-for="(doc, index) in data"
      >
        <vs-td >
          {{ doc.storage_id }}
        </vs-td>
        <vs-td >
          {{ doc.reference_number }}
        </vs-td>

        <vs-td >
          <span class="" v-if="doc.business">{{ doc.business.name }}</span>
          <br v-if="doc.user && doc.business">
          <span v-if="doc.user">{{ doc.user.email }}</span>
        </vs-td>

        <vs-td>
          {{ typeLabel(doc) }}
        </vs-td>

        <vs-td>
          {{ formatDateAndTime(doc.signed_date) }}
        </vs-td>

        <vs-td>
          {{ formatDateAndTime(doc.requested_from_storage_date) }}
        </vs-td>

      </vs-tr>
      </tbody>
    </template>
  </vs-table>
</template>

<script>
  import { textFormat } from '@/mixins/textFormat'
  import { tableHelpers } from '@/mixins/tableHelpers'
  import { documentActions} from "@/mixins/documentActions";

  export default {
    name: 'InStorageTable',
    mixins: [textFormat, tableHelpers, documentActions],
    props: ['data', 'itemsPerPage'],
    computed: {
      documents () {
        return this.data.data
      }
    },
    data () {
      return {
        selected: [],
        searchQuery: '',
        status: 'All'
      }
    },
    methods: {
      search (value) {
        if (value.length > 3 || value === '') {
          this.searchQuery = value
          this.$emit('search', value)
        }
      },
      setFilter (status, value) {
        this.status = status
        this.$emit('filter', value)
      },

      handleSort (key, active) {
        this.$emit('sort', key, active)
      },
      changePage (event) {
        this.$emit('changePage', event)
      }
    }
  }
</script>
